import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details"]

  connect() {
    // Restore expanded state from sessionStorage on connect (after Turbo replacement)
    const key = this.storageKey
    if (key && sessionStorage.getItem(key) === "expanded") {
      this.detailsTarget.classList.remove("hidden")
    }
  }

  toggle() {
    const isHidden = this.detailsTarget.classList.toggle("hidden")
    // Persist state to sessionStorage
    const key = this.storageKey
    if (key) {
      if (isHidden) {
        sessionStorage.removeItem(key)
      } else {
        sessionStorage.setItem(key, "expanded")
      }
    }
  }

  get storageKey() {
    // Use the tbody id (e.g., "package-row-pack_xxx") as the key
    return this.element.id ? `expandable-row-${this.element.id}` : null
  }
}
